export default __webpack_public_path__ + "static/media/2.65f627bd.jpeg";